































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import TemplateTable from "@/components/contentset/manager/TemplateTable.vue";
import ContentConfiguration from "@/components/contentset/manager/ContentConfiguration.vue";
import PreviousContentVersion from "@/components/contentset/manager/PreviousContentVersion.vue";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { IContentSet } from "../../../models/interfaces/content/content-set.model.interface";

const ContentSetVersionModule = namespace("contentSetVersionModule");
const ContentSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader,
    TemplateTable,
    ContentConfiguration,
    PreviousContentVersion
  }
})
export default class PreviousContent extends Vue {
  @ContentSetVersionModule.Action public retrievePreviousVersions;
  @ContentSetVersionModule.Getter public previous;
  @ContentSetModule.Getter public contentSet;

  get getContentSetModel(): IContentSet {
    return this.contentSet;
  }

  get getPreviousArray(): IContentSetVersion[] {
    return this.previous;
  }

  private loading: boolean = true;

  private contentSetVersions: IContentSetVersion[] = [];

  @Watch("getContentSetModel", { deep: true })
  public onContentSetUpdate() {
    this.getPreviousContentSetVersion();
  }

  @Watch("getPreviousArray.0.contentSetVersionId", { deep: true })
  public onPreviousUpdate(val, oldVal) {
    if (oldVal !== val || this.loading) {
      this.updateVersions();
    }
  }

  @Watch("getPreviousArray.0.templates.0.performance.id")
  public onPreviousPerformanceUpdate(val, oldVal) {
    if (oldVal !== val || this.loading) {
      this.updateVersions();
    }
  }

  @Watch("getPreviousArray.0.templates.0.enquiry.templateId")
  public onPreviousEnquiryUpdate(val, oldVal) {
    if (oldVal !== val || this.loading) {
      this.updateVersions();
    }
  }

  public emptyVersions() {
    this.loading = true;
    this.contentSetVersions.splice(0, this.contentSetVersions.length);
  }

  public updateVersions() {
    this.emptyVersions();

    if (this.getPreviousArray && this.getPreviousArray.length > 0) {
      this.getPreviousArray.forEach((element, i) => {
        this.$set(this.contentSetVersions, i, element);

        if (element.templates) {
          element.templates.forEach((template, j) => {
            this.$set(element.templates, j, template);
          });
        }
      });

      this.loading = false;
    }
  }

  public created() {
    this.getPreviousContentSetVersion();
  }

  private getPreviousContentSetVersion() {
    this.emptyVersions();
    if (this.contentSet.contentSetId > 0) {
      this.retrievePreviousVersions().then((result) => {
        if (result === true) {
          this.updateVersions();
        }

        this.loading = false;
      });
    }
  }
}
